import {GetSeferData} from "SeferPetach/GetData";


export async function getSystemLists() {
    var sector_list           = await GetSeferData("sf1",    {});
    var position_list         = await GetSeferData("cpf1",    {});
    var img_list              = await GetSeferData("af3",    {'TYPE_ID': 1, 'ITEM_STATUS': 1});
    var sys_list        = {
        SECTOR_LIST:    [{'SECTOR_ID': 0, 'SECTOR_DESC': "Selecionar"}],
        POSITION_LIST:  [{'COMPANY_POSITION_ID': 0, 'COMPANY_POSITION_DESC': "Selecionar"}],
        IMAGE_LIST:     []
    };
    let i = 0;
    if (sector_list?.response?.content && position_list?.response?.content && img_list?.response?.content) {
        i = 0;
        while (i < sector_list.response.content.length) {
            sys_list.SECTOR_LIST.push({
                'SECTOR_ID':    sector_list.response.content[i].SECTOR_ID,
                'SECTOR_DESC':  sector_list.response.content[i].SECTOR_DESC
            });
            ++i;
        }
        i = 0;
        while (i < position_list.response.content.length) {
            sys_list.POSITION_LIST.push({
                'COMPANY_POSITION_ID':      position_list.response.content[i].COMPANY_POSITION_ID,
                'COMPANY_POSITION_DESC':    position_list.response.content[i].COMPANY_POSITION_DESC
            });
            ++i;
        }
        i = 0;
        while (i < img_list.response.content.length) {
            sys_list.IMAGE_LIST.push({
                'FILE_ID':      img_list.response.content[i].FILE_ID,
                'FILE_DESC':    img_list.response.content[i].FILE_DESC,
                'FILE_DATA':    img_list.response.content[i].FILE_DATA
            });
            ++i;
        }
    }   
    return (sys_list);
}

export async function getUserList() {
    var args = {};
    var payload = await GetSeferData("uf4", args);
    return (payload);
}

export async function getUserByID(user_id){
    var args = {
        'USER_ID': user_id
    };
    var payload = await GetSeferData("uf1", args);
    return (payload);
}

export async function updateUser(obj) {
    var args = {
        'USER_ID'               :   obj.USER_ID,
        'EMAIL'                 :   obj.EMAIL,
        'FIRST_NAME'            :   obj.FIRST_NAME,
        'LAST_NAME'             :   obj.LAST_NAME,
        'COMPANY_POSITION_ID'   :   obj.COMPANY_POSITION_ID,
        'SECTOR_ID'             :   obj.SECTOR_ID,
        'STATUS_ID'             :   obj.STATUS_ID,
        'FILE_ID'               :   obj.FILE_ID,
        'RESTRICTED_ACCESS'     :   obj.RESTRICTED_ACCESS,
        'RESTRICTED_DATA'       :   obj.RESTRICTED_DATA
    };
    var payload = await GetSeferData("uf2", args);
    return (payload);
}

export async function deleteUser(user_id){
    var args = {
        'USER_ID': user_id
    };
    var payload = await GetSeferData("uf3", args);
    return (payload);
}